// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

interface XListFilterStateType {
    filterDrawerIsOpen?: boolean;
}

export const initialListFilterState: XListFilterStateType = {
    filterDrawerIsOpen: false,
};

const reducer = {
    "xListFilter/FilterDrawer/SetFilterDrawerIsOpen": (
        draft: Draft<XListFilterStateType>,
        action: { filterDrawerIsOpen: boolean },
    ) => {
        draft.filterDrawerIsOpen = action.filterDrawerIsOpen;
    },
};

const xListFilter = createTypedReducerWithImmer(initialListFilterState, reducer);

(reducers as any).xListFilter = xListFilter;

export type xListFilterState = {
    xListFilter: XListFilterStateType;
} & ApplicationState;

type xListFilterReducers = {
    [key: string]: typeof xListFilter;
};

export type xListFilterActions = Parameters<xListFilterReducers[keyof xListFilterReducers]>[1] | AnyAction;
